var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppDialog",
    {
      attrs: {
        activatorText: "New",
        title: "Create New Center",
        action: "Add",
        "action-disabled": _vm.doesCenterHaveEmptyFields()
      },
      on: {
        action: function($event) {
          return _vm.handleAdd()
        }
      }
    },
    [
      _c("v-text-field", {
        attrs: { label: "Name", outlined: "" },
        model: {
          value: _vm.center.name,
          callback: function($$v) {
            _vm.$set(_vm.center, "name", $$v)
          },
          expression: "center.name"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "City", outlined: "" },
        model: {
          value: _vm.center.city,
          callback: function($$v) {
            _vm.$set(_vm.center, "city", $$v)
          },
          expression: "center.city"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Country", outlined: "" },
        model: {
          value: _vm.center.country,
          callback: function($$v) {
            _vm.$set(_vm.center, "country", $$v)
          },
          expression: "center.country"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: {
          label: "Province",
          outlined: "",
          hint: "Optional",
          "persistent-hint": true
        },
        model: {
          value: _vm.center.province,
          callback: function($$v) {
            _vm.$set(_vm.center, "province", $$v)
          },
          expression: "center.province"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }